(function () {
  function showPanel(tabsx, labelId) {
    var root = tabsx.closest('.getcri');
    if (!root) return;
    root.querySelectorAll('.getmecon .getcc').forEach(function (panel) {
      panel.style.display = 'none';
    });
    var panel = root.querySelector('.getmecon .' + labelId);
    if (panel) panel.style.display = 'block';
  }

  function measureBenefitsHeight(benefits) {
    if (!benefits) return 0;

    var previous = {
      display: benefits.style.display,
      visibility: benefits.style.visibility,
      position: benefits.style.position,
      width: benefits.style.width,
      pointerEvents: benefits.style.pointerEvents
    };

    benefits.style.display = 'block';
    benefits.style.visibility = 'hidden';
    benefits.style.position = 'absolute';
    benefits.style.width = '100%';
    benefits.style.pointerEvents = 'none';

    var height = benefits.offsetHeight;

    benefits.style.display = previous.display;
    benefits.style.visibility = previous.visibility;
    benefits.style.position = previous.position;
    benefits.style.width = previous.width;
    benefits.style.pointerEvents = previous.pointerEvents;

    return height;
  }

  function lockBenefitsPanelHeight(tabsx) {
    var root = tabsx.closest('.getcri');
    if (!root) return;

    var container = root.querySelector('.getmecon');
    var benefits = root.querySelector('.getmecon .getc1');
    if (!container || !benefits) return;

    var height = measureBenefitsHeight(benefits);
    if (height > 0) {
      container.style.minHeight = height + 'px';
    }
  }

  function syncActiveLabel(tabsx) {
    var checked = tabsx.querySelector('input[type="radio"]:checked');
    if (!checked) return;
    tabsx.querySelectorAll('label.tabo').forEach(function (label) {
      label.classList.toggle('active', label.getAttribute('for') === checked.id);
    });
    var label = tabsx.querySelector('label[for="' + checked.id + '"]');
    if (label && label.id) showPanel(tabsx, label.id);
  }

  function moveGlider(tabsx) {
    var glider = tabsx.querySelector('.glider1');
    var checked = tabsx.querySelector('input[type="radio"]:checked');
    if (!glider || !checked) return;

    var labels = tabsx.querySelectorAll('label.tabo');
    var label = tabsx.querySelector('label[for="' + checked.id + '"]');
    if (!label) return;

    var index = Array.prototype.indexOf.call(labels, label);
    var isFirst = index === 0;
    var isLast = index === labels.length - 1;

    glider.classList.remove('is-first', 'is-middle', 'is-last');
    if (isFirst) {
      glider.classList.add('is-first');
    } else if (isLast) {
      glider.classList.add('is-last');
    } else {
      glider.classList.add('is-middle');
    }

    var x = isFirst ? 0 : label.offsetLeft;
    var width = isLast ? tabsx.clientWidth - x : label.offsetWidth;

    glider.style.width = width + 'px';
    glider.style.height = tabsx.offsetHeight + 'px';
    glider.style.transform = 'translateX(' + x + 'px)';
  }

  function initTabsx(tabsx) {
    syncActiveLabel(tabsx);
    moveGlider(tabsx);
    lockBenefitsPanelHeight(tabsx);

    tabsx.querySelectorAll('input[type="radio"]').forEach(function (input) {
      input.addEventListener('change', function () {
        syncActiveLabel(tabsx);
        moveGlider(tabsx);
      });
    });

    tabsx.querySelectorAll('label.tabo').forEach(function (label) {
      label.addEventListener('click', function () {
        window.requestAnimationFrame(function () {
          syncActiveLabel(tabsx);
          moveGlider(tabsx);
        });
      });
    });
  }

  function init() {
    document.querySelectorAll('.gettok.rb-get-to-know .tabsx').forEach(initTabsx);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('load', init);

  window.addEventListener('resize', function () {
    document.querySelectorAll('.gettok.rb-get-to-know .tabsx').forEach(function (tabsx) {
      moveGlider(tabsx);
      lockBenefitsPanelHeight(tabsx);
    });
  });

  if (typeof ResizeObserver !== 'undefined') {
    document.querySelectorAll('.gettok.rb-get-to-know .tabsx').forEach(function (tabsx) {
      var root = tabsx.closest('.getcri');
      var container = root && root.querySelector('.getmecon');
      var observer = new ResizeObserver(function () {
        moveGlider(tabsx);
        lockBenefitsPanelHeight(tabsx);
      });
      observer.observe(tabsx);
      if (container) observer.observe(container);
    });
  }
})();
